import { jsx as r, jsxs as l, Fragment as _ } from "react/jsx-runtime";
import { useMemo as g } from "react";
import { c } from "../../index-C7ezJk5b.js";
import { I as h } from "../../caret - sip up-D4yNqZGG.js";
import { b as I } from "../../base-nYmjnkiN.js";
import { toPascalCase as s } from "../../core/utils/string.js";
import { cssX as t, cssTI as p } from "../../core/utils/css.js";
import M from "../../components/Dropdown/Dropdown.js";
import "react-dom";
import b from "../../components/Tooltip/Tooltip.js";
import w from "../../components/Wrapper/Wrapper.js";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
import { NavigationItem as x } from "./NavigationItem.js";
const d = ({
  data: e
}) => /* @__PURE__ */ r(
  "a",
  {
    href: e.url,
    target: "_blank",
    className: c(t("Dropdown__item"), "is-tall"),
    style: { whiteSpace: "nowrap" },
    "data-testid": p("button", `PlatformNavigationMoreProductsItem${s(e.name ?? "")}`),
    children: e.name
  }
), W = ({
  moreProductsButtonRef: e,
  isMoreProductsDropdownOpened: u,
  setIsMoreProductsDropdownOpened: f
}) => {
  const {
    userInfo: {
      products: P,
      productsSections: v,
      moreProducts: a
    }
  } = I(), N = g(
    () => {
      if (a.length > 5) {
        const o = Math.floor(a.length / 2), m = a.slice(0, o), n = a.slice(o);
        return [
          {
            id: "column1",
            items: m.map((i) => ({
              id: i.name,
              content: /* @__PURE__ */ r(d, { data: i }, i.name)
            }))
          },
          {
            id: "column2",
            items: n.map((i) => ({
              id: i.name,
              content: /* @__PURE__ */ r(d, { data: i }, i.name)
            }))
          }
        ];
      }
      return [
        {
          id: "moreProducts",
          items: a.map((o) => ({
            id: o.name,
            content: /* @__PURE__ */ r(d, { data: o }, o.name)
          }))
        }
      ];
    },
    [a]
  );
  return /* @__PURE__ */ l(
    "div",
    {
      className: t("PlatformNavigation__full-dropdown"),
      onMouseLeave: () => f(!1),
      children: [
        /* @__PURE__ */ r(w, { className: t("PlatformNavigation__columns"), children: v.map((o) => /* @__PURE__ */ l(
          "div",
          {
            className: c(
              t("PlatformNavigation__column"),
              t("PlatformProductsGroup")
            ),
            children: [
              /* @__PURE__ */ r(
                "div",
                {
                  className: t("PlatformProductsGroup__header"),
                  children: /* @__PURE__ */ r(
                    "div",
                    {
                      "data-testid": p("text", `PlatformNavigation${s(o.id)}`),
                      "data-tooltip-id": t(`PlatformNavigationSectionTitle${s(o.id)}`),
                      children: o.title.toUpperCase()
                    }
                  )
                }
              ),
              !!o.description && /* @__PURE__ */ r(
                b,
                {
                  id: t(`PlatformNavigationSectionTitle${s(o.id)}`),
                  place: "left",
                  children: /* @__PURE__ */ r("div", { dangerouslySetInnerHTML: { __html: o.description } })
                }
              ),
              /* @__PURE__ */ r("div", { className: t("PlatformProductsGroup__body"), children: o.items.map((m) => {
                const n = P[m];
                return n ? /* @__PURE__ */ r(
                  x,
                  {
                    data: n
                  },
                  m
                ) : null;
              }) })
            ]
          },
          o.id
        )) }),
        a.length > 0 && /* @__PURE__ */ l(_, { children: [
          /* @__PURE__ */ l(
            "div",
            {
              ref: e,
              className: c(
                t("PlatformNavigation__more-products"),
                t("Interactive")
              ),
              "data-tooltip-id": t("MoreProducts"),
              onClick: () => f(!u),
              "data-testid": p("button", "PlatformNavigationMoreProducts"),
              children: [
                "...more",
                /* @__PURE__ */ r(h, { className: t("PlatformNavigation__more-products-icon") })
              ]
            }
          ),
          /* @__PURE__ */ r(
            M,
            {
              id: t("MoreProducts"),
              isOpened: u,
              columns: N,
              place: "top-end"
            }
          )
        ] })
      ]
    }
  );
};
export {
  W as NavigationProducts
};
